"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionLink = void 0;
var react_1 = __importDefault(require("react"));
var vdl_prefix_1 = require("../util/vdl-prefix");
var classnames_1 = require("../util/classnames");
var ActionLink = /** @class */function (_super) {
  __extends(ActionLink, _super);
  function ActionLink() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ActionLink.prototype.render = function () {
    var _a;
    var _b = this.props,
      children = _b.children,
      className = _b.className,
      disabled = _b.disabled,
      onClick = _b.onClick,
      otherProps = __rest(_b, ["children", "className", "disabled", "onClick"]);
    var linkClasses = (_a = {}, _a[vdl_prefix_1.vdlPrefix('action-link')] = true, _a[vdl_prefix_1.vdlPrefix('action-link--disabled')] = disabled, _a);
    if (disabled) {
      return react_1.default.createElement("span", __assign({
        className: classnames_1.classNames(linkClasses, className)
      }, otherProps), children);
    } else {
      return react_1.default.createElement("a", __assign({
        className: classnames_1.classNames(linkClasses, className),
        onClick: onClick
      }, otherProps), children);
    }
  };
  return ActionLink;
}(react_1.default.Component);
exports.ActionLink = ActionLink;